import type { FC } from "react";
import type { IconCommonProps } from "@/icons/shared.ts";

export const IconKeyboard: FC<IconCommonProps> = ({ width, height, color }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={width ?? 24}
      height={height ?? 24}
      fill="none"
      stroke={color ?? "#000000"}
      strokeWidth="1"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M10 8h.01M12 12h.01M14 8h.01M16 12h.01M18 8h.01M6 8h.01M7 16h10m-9-4h.01" />
      <rect width="20" height="16" x="2" y="4" rx="2" />
    </svg>
  );
};
